import { render, staticRenderFns } from "./PaperlessNG.vue?vue&type=template&id=94ffc72c&"
import script from "./PaperlessNG.vue?vue&type=script&lang=js&"
export * from "./PaperlessNG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports